import { useState, useEffect } from 'react';
/* datas */
import { HostBackend } from '../../../../Routes/HostBackend.js';
import { GetHeaders } from '../../../../Components/Admin/Functions/FetchHeaders.js';
/* document */
import { Select } from '../../Form/Inputs/Select.js';
import { Text } from '../../Form/Inputs/Text.js';
import { Textarea } from '../../Form/Inputs/Textarea.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const DescribePage = (props) => {
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [linkChooser, setLinkChooser] = useState([]);
    const name = (props.el) ? props.el.name : '';
    const description = (props.el) ? props.el.description : '';
    const id_link = (props.el) ? props.el.id_link : '';
    const id = (props.el) ? props.el.id : '';
    useEffect(() => {
        const fetchData = async () => {
            const datasLinks = await fetch(`${backend}/admin/collection/outlinks`, GetHeaders(token));
            const linkChooser = await datasLinks.json();
            setLinkChooser(linkChooser);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Text name="name" value={name} />
            <Textarea name="description" value={description} />
            <Select name="id_link" choosers={linkChooser} value={id_link} />
            <Hidden name="id" value={id} />
        </>
    )
}